import React, { useState } from 'react';
// @ts-ignore
import { Row, Cell } from '@els/els-react--table';
// @ts-ignore
import { Button } from '@els/els-react--button';
// @ts-ignore
import { LinkElement } from '@els/els-react--link-element';
// @ts-ignore
import { Icon } from '@els/els-react--icon';
// @ts-ignore
import { Modal } from '@els/els-react--modal';
import { useDispatch } from 'react-redux';
import { formatDate } from '../../../../libs/utils/helper/date-helper';
import { deleteFavoriteContent } from '../skills-favorite-tab/skills-favorite-tab-thunk';

interface SkillsListRowProps {
    id: number;
    courseId: number;
    skillTitle: string;
    favoriteDate: string;
    className: string;
    handleRedirectToSkillDetail: (courseId: number) => void;
}

const SkillsFavoriteListRow = ({
    id,
    skillTitle,
    className,
    favoriteDate,
    courseId,
    handleRedirectToSkillDetail,
}: SkillsListRowProps) => {
    const dispatch = useDispatch();
    const baseClassName = `${className}__row`;
    const modalbaseClassName = `${className}__modal`;
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleRemoveFavorite = (id: any) => () => {
        dispatch(deleteFavoriteContent(id));
        setIsModalOpen(false);
        window.scrollTo(0, 0);
    };
    return (
        <>
            <Row className={`${baseClassName}`}>
                <Cell className={`${baseClassName}__cell-skill-name`}>
                    <LinkElement
                        className={`${baseClassName}__cell-button`}
                        inline
                        href=""
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            handleRedirectToSkillDetail(courseId);
                        }}
                    >
                        {skillTitle}
                    </LinkElement>
                </Cell>
                <Cell className={`${baseClassName}__cell-favorite-date`}>
                    {favoriteDate && formatDate(favoriteDate, 'M/d/yyyy')}
                </Cell>
                <Cell className={`${baseClassName}__cell-remove-skill`}>
                    <Button type="link" onClick={() => setIsModalOpen(true)}>
                        <Icon
                            id="remove"
                            sprite="Trash"
                            isVisible
                            a11y={{
                                name: 'Icon Name',
                                description: 'Icon description',
                            }}
                        />
                    </Button>
                </Cell>
            </Row>
            {isModalOpen && (
                <Modal onClose={() => setIsModalOpen(false)} id="modal-id">
                    <div className={`${modalbaseClassName}`}>
                        <div className={`${modalbaseClassName}__title-wrapper`}>
                            <h2>Confirm removal</h2>
                        </div>
                        <div
                            className={`${modalbaseClassName}__content-wrapper`}
                        >
                            <p>
                                Are you sure you would like to remove this skill
                                as a favorite? You are able to re-add this as a
                                favorite in the future.
                            </p>
                        </div>
                        <div
                            className={`${modalbaseClassName}__button-wrapper`}
                        >
                            <Button
                                type="secondary"
                                onClick={() => setIsModalOpen(false)}
                                className={`${modalbaseClassName}__button-wrapper-cancel`}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="warn"
                                onClick={handleRemoveFavorite(id)}
                                className={`${modalbaseClassName}__button-remove`}
                            >
                                Yes, remove
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};
export default SkillsFavoriteListRow;
